// src/components/Admin/SellerManagement/Notes/AddNoteForm.jsx
import React, { useState } from 'react';
import { Button } from "../../../../components/ui/button";
import { Textarea } from "../../../../components/ui/textarea";
import { useToast } from "../../../../hooks/use-toast";

const AddNoteForm = ({ onSubmit, isLoading }) => {
  const [content, setContent] = useState("");
  const { toast } = useToast();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (content.trim().length < 3) {
      toast({
        title: "Note is too short",
        description: "Please enter a more detailed note.",
        variant: "destructive",
      });
      return;
    }
    onSubmit(content);
    setContent("");
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-2">
      <Textarea
        placeholder="Add a new note for this tab..."
        value={content}
        onChange={(e) => setContent(e.target.value)}
        rows={3}
      />
      <Button type="submit" disabled={isLoading || !content.trim()}>
        {isLoading ? "Adding Note..." : "Add Note"}
      </Button>
    </form>
  );
};

export default AddNoteForm;